import React from "react";
import Theme from "@adsk/alloy-react-theme";
export const ButtonDivider = () => {
  return (
    <div
      style={{
        borderLeft: `1px solid ${Theme.colors.charcoal200}`,
        margin: "8px 0px",
        minHeight: 20,
      }}
    />
  );
};
